import React from 'react';
import classnames from 'classnames';
import Img from 'graphcms-image';

import Heading from './renderers/Heading';
import MarkdownRenderer from './MarkdownRenderer';
import Button from './Button';

const ContentBlock = ({ image, title, content, cta, ctaTo }, index) => {
  const isEven = index % 2;

  const wrapperClass = classnames(
    '-mx-6 flex items-center flex-col lg:flex-row py-6 lg:py-12',
    {
      'lg:flex-row-reverse': isEven,
    }
  );

  return (
    <article key={index} className={wrapperClass}>
      <div className="w-full lg:w-1/2 px-6 flex items-center justify-center mb-6 lg:mb-0">
        {image && (
          <div className="m-auto relative z-20 w-full h-full">
            <Img
              image={image}
              title={title}
              alt={title}
              className="rounded"
              maxWidth={760}
              transforms={['quality=value:75']}
              withWebp
            />
          </div>
        )}
      </div>

      <div className="w-full lg:w-1/2 px-6">
        <div className="-mt-6">
          {title && <Heading level={4} children={title} />}

          <MarkdownRenderer content={content} />

          {ctaTo && (
            <Button href={ctaTo} colour="purple">
              {cta ? cta : 'Learn more'} &#8594;
            </Button>
          )}
        </div>
      </div>
    </article>
  );
};

export default ContentBlock;
